import React from "react";
import { FiSearch, FiX } from "react-icons/fi";
import FilterIcon from "../../../../assets/icons/filter.svg";

interface CustomerListHeaderProps {
  searchQuery: string;
  onSearch: (query: string) => void;
  onClearSearch: () => void;
  onFilter: () => void;
  filterCount: number;
}

const CustomerListHeader: React.FC<CustomerListHeaderProps> = ({
  searchQuery,
  onSearch,
  onClearSearch,
  onFilter,
  filterCount,
}) => {
  return (
    <div className="customer-list-header">
      <div className="search-container">
        <FiSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search for customer name"
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
        />
        {searchQuery && (
          <button className="clear-search-btn" onClick={onClearSearch}>
            <FiX />
          </button>
        )}
      </div>

      <div className="filter-link" onClick={onFilter}>
        Search filter
        <img src={FilterIcon} alt="Filter" />
        {filterCount > 0 && <span className="filter-badge">{filterCount}</span>}
      </div>
    </div>
  );
};

export default CustomerListHeader;
